var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMailFill = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/ui/mail"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 18L20 6L4 6L4 18L20 18Z",
    fill: "#003764"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 8",
    d: "M4 8L12 13L20 8",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMailFill);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mail-fill.9aa0d174d0bd63e0bca885263292e9be.svg";